/*------------------------------------*\
    MODULES
\*------------------------------------*/
import 'htmx.org';
import BookingForm from './modules/booking-form';
import Carousel from './modules/carousel';
import CarouselCottage from './modules/carousel-cottage';
import CarouselTestimonial from './modules/carousel-testimonial';
import CarouselVenue from './modules/carousel-venue';
import GoogleMap from './modules/google-map';
import Map from './modules/map';
import Menu from './modules/menu';
import Modal from './modules/modal';
import Nav from './modules/nav';
import Scroll from './modules/scroll';
import Scroller from './modules/scroller';
import Tabs from './modules/tabs';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');
            // Loop and bind to relevant modules
            modules.map((module) => {
                switch (module.trim()) {
                    case 'booking-form':
                        let bookingFormInstance = new BookingForm(item);
                        bookingFormInstance.init();
                        break;

                    case 'tabs':
                        let tabsInstance = new Tabs(item);
                        tabsInstance.init();
                        break;

                    case 'map':
                        let mapInstance = new Map(item);
                        mapInstance.init();
                        break;

                    case 'menu':
                        let menuInstance = new Menu(item);
                        menuInstance.init();
                        break;

                    case 'modal':
                        let modalInstance = new Modal(item);
                        modalInstance.init();
                        break;

                    case 'nav':
                        let navInstance = new Nav(item);
                        navInstance.init();
                        break;

                    case 'carousel':
                        let carouselInstance = new Carousel(item);
                        carouselInstance.init();
                        break;

                    case 'carousel-cottage':
                        let CarouselCottageInstance = new CarouselCottage(item);
                        CarouselCottageInstance.init();
                        break;  

                    case 'carousel-testimonial':
                        let CarouselTestimonialInstance = new CarouselTestimonial(item);
                        CarouselTestimonialInstance.init();
                        break;  

                    case 'carousel-venue':
                        let CarouselVenueInstance = new CarouselVenue(item);
                        CarouselVenueInstance.init();
                        break;                        

                    case 'scroll':
                        let ScrollInstance = new Scroll(item);
                        ScrollInstance.init();
                        break; 

                    case 'scroller':
                        let ScrollerInstance = new Scroller(item);
                        ScrollerInstance.init();
                        break; 

                    case 'google-map':
                        let googleMapInstance = new GoogleMap(item);
                        googleMapInstance.init();
                        break;    
                }
            });
        });
    },

    alwaysLoad() {

    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
